<template>
<div class="column is-12">
            <!----------- headline ---------------------------------->
            <div class="field">
              <label class="label">{{ elLabel }}</label>
              <div class="control has-icons-right">
                <input 
                maxlength="500"
                class="input" 
                type="text" 
                v-validate="'required'" 
                :class="{'input': true, 'is-danger': errors.has('headline') }" 
                :value="data"
                @input="$emit('wasUpdated', $event.target.value)"
                name="headline">
                <span class="icon is-right" v-show="errors.has('headline')">
                  <i class="fa fa-warning"></i>
                </span>
                <span v-show="errors.has('headline')" class="help is-danger">{{ isEmpty }}</span>
              </div>
            </div>
</div>
</template>

<script>
export default {
  inject: ['$validator'],
  props: ['data', 'isEmpty', 'elLabel'],
  data () {
    return {
    }
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/cms/elements/Headline.vue